import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const MPManomanoIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        id="Manomano"
        data-name="Manomano"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 132.51 80.52"
        strokeWidth={0}
        fill="currentColor"
      >
        <title>Manomano</title>
        <linearGradient
          id="Dégradé_sans_nom_2"
          data-name="Dégradé sans nom 2"
          x1="163.06"
          y1="-378.39"
          x2="163.6"
          y2="-378.85"
          gradientTransform="translate(-5131.35 11330.52) scale(31.5 29.82)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#0397a7" />
          <stop offset="1" stopColor="#00eccd" />
        </linearGradient>
        <path
          fill="url(#Dégradé_sans_nom_2)"
          d="m29.7,36.66l-8.03-9.8c-.59-.72-1.49-1.05-2.38-.92l-12.57,2.03c-.9.15-1.67.74-2,1.62L.16,41.38c-.31.85-.18,1.82.38,2.51l8.03,9.77c.59.72,1.49,1.05,2.38.92l12.59-2c.9-.15,1.67-.74,2-1.62l4.56-11.8c.33-.85.18-1.8-.41-2.51Z"
        />
        <polygon
          fill="#fff"
          points="18.58 34.58 15.75 39.61 12.96 33.63 9.47 34.56 5.19 45.74 9.01 45.74 11.63 39.15 14.16 45.4 16.11 45.4 19.88 38.68 19.88 47.3 23.47 46.07 23.47 35.45 18.58 34.58"
        />
        <path
          fill={themeColor === 'light' ? '#0c193a' : '#fff'}
          d="m73.17,38.76c.97-.92,2.15-1.36,3.56-1.36s2.62.44,3.56,1.36c.97.9,1.44,2.05,1.44,3.49s-.49,2.56-1.44,3.46c-.95.87-2.13,1.33-3.56,1.33s-2.62-.44-3.56-1.33c-.95-.9-1.41-2.05-1.41-3.46s.49-2.59,1.41-3.49Zm3.59,5.59c1.05,0,1.9-.82,1.9-2.1s-.85-2.13-1.9-2.13-1.9.87-1.9,2.13.85,2.1,1.9,2.1Zm-9.13-6.92c2.15,0,3.08,1.13,3.08,3.15v6.23h-3.46v-5.51c0-.56-.21-.9-.64-.9-.41,0-1.21.15-1.72.49v5.95h-3.44v-9.21h2.85l.18.69c.56-.36,1.9-.85,2.92-.87l.23-.03h0Zm-22.54-1.82l4.97.87v10.59l-3.64,1.21v-8.57l-3.82,6.77h-2l-2.59-6.31-2.64,6.62h-3.9l4.36-11.23,3.54-.95,2.85,6.03,2.87-5.03h0Zm6.9,2.28c2.51-.44,8.18-1.74,8.21,3.36v5.59h-2.64l-.21-.44s-.92.69-2.9.69c-2.15,0-3.31-1.46-3.31-2.9,0-2.33,2.08-2.9,4.44-2.9h1.64c0-.95-.59-1.31-1.82-1.28-1.74,0-3.13.38-3.41.49v-2.62h0Zm5.23,5.44v-.1l-1.54-.03c-1.21,0-1.8.18-1.8.79s.51.85,1.36.85c1.28.03,1.97-.44,1.97-1.51Zm66.73-4.56c.97-.92,2.15-1.36,3.56-1.36s2.62.44,3.56,1.36c.97.9,1.44,2.05,1.44,3.49s-.49,2.56-1.44,3.46c-.95.87-2.13,1.33-3.56,1.33s-2.62-.44-3.56-1.33c-.95-.9-1.41-2.05-1.41-3.46-.03-1.41.44-2.59,1.41-3.49Zm3.56,5.59c1.05,0,1.9-.82,1.9-2.1s-.85-2.13-1.9-2.13-1.9.87-1.9,2.13c0,1.26.85,2.1,1.9,2.1Zm-9.13-6.92c2.15,0,3.05,1.13,3.05,3.15v6.23h-3.46v-5.51c0-.56-.21-.9-.64-.9-.41,0-1.21.15-1.72.49v5.95h-3.44v-9.21h2.85l.18.69c.56-.36,1.9-.85,2.92-.87l.26-.03h0Zm-22.54-1.82l4.97.87v10.59l-3.64,1.21v-8.57l-3.85,6.77h-1.97l-2.59-6.31-2.64,6.62h-3.9l4.36-11.23,3.54-.95,2.85,6.03,2.87-5.03h0Zm6.87,2.28c2.51-.44,8.21-1.74,8.21,3.36v5.59h-2.64l-.21-.44s-.92.69-2.9.69c-2.15,0-3.31-1.46-3.31-2.9,0-2.33,2.08-2.9,4.44-2.9h1.64c0-.95-.59-1.31-1.82-1.28-1.74,0-3.13.38-3.41.49v-2.62h0Zm5.26,5.44v-.1l-1.54-.03c-1.21,0-1.8.18-1.8.79s.51.85,1.36.85c1.28.03,1.97-.44,1.97-1.51Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default MPManomanoIcon;
